import { Modal, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setOpenKyc } from '../../src/redux/slices/payment';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "487px",
      background: "#242033",
      borderRadius: "10px",
      color: "white",
      padding:"50px",
      '@media(max-width:480px)':{
        padding:"15px",
      },
    },
    paper: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      margin: "auto",
      padding: "10px",
    },
    popupTitle:{
      padding: "17px 0px", 
      borderBottom: "0.5px solid rgba(255, 255, 255, 0.5)",
      '& p':{
        fontSize:"12px",
      },
    },
    popupDescription:{
      padding: "17px 0px", 
      borderBottom: "0.5px solid rgba(255, 255, 255, 0.5)",
      '& p':{
        fontSize:"10px",
        marginBottom:"10px"
      },
    },
    popupDescription2:{
      padding: "17px 0px", 
      '& p':{
        fontSize:"10px",
        marginBottom:"10px",
        fontWeight:"400"
      },
    },
    gradText: {
      position:"relative",
      display:"block",
      width:"100%",
      maxWidth:"125px",
      background:"transparent",
      color:"#fff",
      fontSize:"10px",
      borderRadius:"7px",
      height:"37px",
      border:"1px solid #ccc",
      marginRight:"10px",
      fontWeight:"400"
    },
    btn: {
      width: "100%",
      borderRadius: "7px",
      background:"linear-gradient(90deg, #F30B81 0%, #4330FF 52.6%, #2CACC6 100%)",
      color:"#fff",
      fontSize:"10px",
      fontWeight:"400",
      textTransform:"capitalize",
      height: "37px",
      cursor: "pointer",
      position:"relative",
      display:"block",
      border:"none"
    },
    flex: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      position:"relatibve",
      padding:"16px 0"
    },
    txtField:{
      marginTop: "10px",
      fontSize: "10px",
      fontWeight: "400",
      color:"#ccc",
      width: "100%",
      padding:"0 15px",
      height: "38px",
      borderRadius: "7px",
      background:"transparent",
      border:"1px solid #ccc",
    },
  }));

export const ContactModal = ({onContinue}) => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const {openKyc} = useSelector(state => state.payment)
   const onClose=()=>{
    dispatch(setOpenKyc(false))
   }
  return (
   <>
       <Modal open={openKyc} onClose={()=>{onClose()}}>
        <div className={classes.root}>
            <div className={classes.paper}>
              <div className={classes.popupTitle} >
                <Typography component="p">Enter your 10 digit Phone number</Typography>
              </div>
              <div className={classes.popupDescription2} >
                <Typography component="p">We need your phone number before we can go ahead with your requests to add funds</Typography>
                <input type="text" placeholder="+91" className={classes.txtField} />
              </div>
              <div className={classes.flex}>
                <button type="button"  onClose={()=>{onClose()}} className={classes.gradText}> Cancel </button>
                <button type="submit" className={classes.btn} onClick={()=> {onContinue()}}> Continue </button>
              </div>
            </div>
        </div>
    </Modal>
   </>
  )
}
